const moment = require("moment");

module.exports = {
  formatDate: (date, format = "D MMM YYYY hh:mm A") => {
    return moment(date).format(format);
  },

  formatDateOnly: (date, format = "D MMM YYYY") => {
    return moment(date).format(format);
  },

  getTimeAgo: (timestamp) => {
    const now = new Date();
    const updated = new Date(timestamp);
    const diff = Math.floor((now - updated) / 1000); // in seconds

    if (diff < 5) return "just now";
    if (diff < 60) return `${diff} second${diff > 1 ? "s" : ""} ago`;

    const minutes = Math.floor(diff / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

    const days = Math.floor(hours / 24);

    if (days > 2) {
      return this.formatDate(timestamp);
    }

    return `${days} day${days > 1 ? "s" : ""} ago`;
  },
};
